import { has } from 'ramda';
import React from 'react';
import { Icon } from '../../components/icon';
import { gradients } from '../../theme/foundation/color/color';
export const SpeedHeart = (props)=>{
    const { color ='' , ...iconProps } = props;
    const isGradient = has(color, gradients);
    return /*#__PURE__*/ React.createElement(Icon, {
        viewBox: "0 0 38 23",
        ...!isGradient && {
            color
        },
        ...iconProps
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M35.8112 5.94369C35.4296 5.3302 34.9308 4.7979 34.3435 4.37721C33.7561 3.95652 33.0916 3.65568 32.3879 3.49187C31.6842 3.32807 30.9552 3.3045 30.2424 3.42253C29.5296 3.54056 28.8471 3.79787 28.2338 4.17976L26.961 4.97183L26.169 3.6991C25.3981 2.46036 24.1666 1.57861 22.7456 1.24781C21.3246 0.917005 19.8303 1.16426 18.5916 1.93517C17.3528 2.70609 16.4711 3.93751 16.1403 5.35855C15.8095 6.77959 16.0567 8.27383 16.8277 9.51257L17.6197 10.7853L23.4332 20.1266L32.7745 14.3132L34.0472 13.5211C34.6607 13.1395 35.193 12.6408 35.6137 12.0534C36.0344 11.466 36.3353 10.8015 36.4991 10.0978C36.6629 9.39416 36.6864 8.6651 36.5684 7.95232C36.4504 7.23954 36.1931 6.557 35.8112 5.94369Z",
        fill: isGradient ? 'url(#heart-gradient)' : 'currentColor'
    }), /*#__PURE__*/ React.createElement("rect", {
        fill: isGradient ? 'url(#speed-line-gradient-1)' : 'currentColor',
        height: "3",
        rx: "1.5",
        width: "13",
        x: "0.253906",
        y: "3"
    }), /*#__PURE__*/ React.createElement("rect", {
        fill: isGradient ? 'url(#speed-line-gradient-2)' : 'currentColor',
        height: "3",
        rx: "1.5",
        width: "9",
        x: "4.25391",
        y: "10"
    }), /*#__PURE__*/ React.createElement("rect", {
        fill: isGradient ? 'url(#speed-line-gradient-3)' : 'currentColor',
        height: "3",
        rx: "1.5",
        width: "9",
        x: "7.25391",
        y: "17"
    }), isGradient && /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        gradientUnits: "userSpaceOnUse",
        id: "heart-gradient",
        x1: "21.7949",
        x2: "38.3225",
        y1: "4.87237",
        y2: "19.3541"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: `var(--chakra-colors-gradient-${color}-0)`
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: `var(--chakra-colors-gradient-${color}-1)`
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        gradientUnits: "userSpaceOnUse",
        id: "speed-line-gradient-1",
        x1: "3.61046",
        x2: "6.66082",
        y1: "3.61644",
        y2: "9.7778"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: `var(--chakra-colors-gradient-${color}-0)`
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: `var(--chakra-colors-gradient-${color}-1)`
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        gradientUnits: "userSpaceOnUse",
        id: "speed-line-gradient-2",
        x1: "6.57768",
        x2: "10.2075",
        y1: "10.6164",
        y2: "15.6923"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: `var(--chakra-colors-gradient-${color}-0)`
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: `var(--chakra-colors-gradient-${color}-1)`
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        gradientUnits: "userSpaceOnUse",
        id: "speed-line-gradient-3",
        x1: "9.57768",
        x2: "13.2075",
        y1: "17.6164",
        y2: "22.6923"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: `var(--chakra-colors-gradient-${color}-0)`
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: `var(--chakra-colors-gradient-${color}-1)`
    }))));
};

//# sourceMappingURL=speed-heart.js.map